module.exports = __webpack_public_path__ + "img/move.f41e42ad.svg";